export const OwlMark = ({ className = "h-9 w-9", body = "#1C1917", face = "#FAF8F5", beak = "#C59B27" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <path d="M11 12 L6 2 L19 8 Z" fill={body} />
    <path d="M37 12 L42 2 L29 8 Z" fill={body} />
    <path d="M24 5 C14.5 5 8 12.5 8 21.5 V29 c0 8.3 7.2 14 16 14 s16 -5.7 16 -14 V21.5 C40 12.5 33.5 5 24 5 Z" fill={body} />
    <circle cx="17.5" cy="20" r="5.6" fill={face} />
    <circle cx="30.5" cy="20" r="5.6" fill={face} />
    <circle cx="17.5" cy="20" r="2.3" fill={body} />
    <circle cx="30.5" cy="20" r="2.3" fill={body} />
    <path d="M24 24.5 L20.5 29.5 L27.5 29.5 Z" fill={beak} />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-2.5">
    <OwlMark className="h-8 w-8" body={dark ? "#FAF8F5" : "#1C1917"} face={dark ? "#1C1917" : "#FAF8F5"} />
    <span className={`font-serif text-xl tracking-tight ${dark ? "text-bone" : "text-ink"}`}>
      The Owl&rsquo;s Nest
    </span>
  </span>
);
